__turbopack_context__.v({
  "card-field": "CardField-module-scss-module__9RH4IG__card-field",
  "card-field-active": "CardField-module-scss-module__9RH4IG__card-field-active",
  "card-field-btn": "CardField-module-scss-module__9RH4IG__card-field-btn",
  "card-field-error": "CardField-module-scss-module__9RH4IG__card-field-error",
  "drag-to-reorder-handle": "CardField-module-scss-module__9RH4IG__drag-to-reorder-handle",
  "edit-icon": "CardField-module-scss-module__9RH4IG__edit-icon",
  "field-row-container": "CardField-module-scss-module__9RH4IG__field-row-container",
  "lock-message-fade-in": "CardField-module-scss-module__9RH4IG__lock-message-fade-in",
});
